// @ts-nocheck

export default {
    name: 'RiskLevelMixin',
    computed: {
        mixinRiskLevelColor() {
            return {
                2: 'low',
                low: 'green',
                1: 'medium',
                medium: 'medium',
                0: 'high',
                high: 'high',
            }
        },
    },
    methods: {
        mixinGetRiskLevel(score?: number, scoreBucket?: string) {
            if (!score) return null

            if (scoreBucket) {
                return this.mixinRiskLevelColor[scoreBucket]
            }

            if (score <= 3) {
                return this.mixinRiskLevelColor.low
            } else if (score <= 6) {
                return this.mixinRiskLevelColor.medium
            }

            return this.mixinRiskLevelColor.high
        },
    },
}
